import { AboutBg } from "assets";
import { useTheme } from "contexts";
import { ABOUT_US_CARDS_CONTENT } from "constants";

export function AboutUs() {
  const { darkMode } = useTheme();

  return (
    <section
      style={{
        backgroundImage: `url(${AboutBg})`,
      }}
      className="bg-cover bg-center bg-no-repeat relative"
      id="about"
    >
      <div
        className={`absolute inset-0 ${darkMode ? "bg-gradient-to-t from-black/70 via-card/80 to-card" : "bg-gradient-to-t from-white/70 via-card/80 to-white/90"}`}
      ></div>

      <div className="container py-24 ">
        <div className="relative text-center">
          <h1 className="heading2">What is Sale SpeedUp?</h1>

          <h2 className="text-lg lg:text-xl text-paragraph max-w-3xl mx-auto leading-relaxed mb-16">
            Sale SpeedUp is more than a CRM. It’s a complete real estate
            performance system that connects your people, processes, and data in
            one place — from first inquiry to final payment.
          </h2>

          <div className="grid md:grid-cols-3 gap-6 text-left">
            {ABOUT_US_CARDS_CONTENT.map((card) => {
              return (
                <div
                  key={card?.id}
                  className="bg-body backdrop-blur-md rounded-3xl p-8 shadow-accent-glow hover:translate-y-3  hover:shadow-accent-glowHover transition duration-300"
                >
                  <h3 className="text-xl font-bold text-secondary mb-4">
                    {card?.title}
                  </h3>
                  <h4 className="leading-relaxed text-muted">
                    {card?.description}
                  </h4>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
